// todo obsolete, use propComparator
export function SortByProperty(data, property, ascendingSorting = false) {
    if (ascendingSorting) {
        return data.sort(function (a, b) {
            if (a[property] > b[property]) {
                return 1;
            }
            if (a[property] < b[property]) {
                return -1;
            }

            // a must be equal to b
            return 0;
        });
    } else {
        return data.sort(function (a, b) {
            if (a[property] < b[property]) {
                return 1;
            }
            if (a[property] > b[property]) {
                return -1;
            }

            // a must be equal to b
            return 0;
        });
    }
}
